import { render, staticRenderFns } from "./CarteiraDashboardApp.vue?vue&type=template&id=52e15dc8"
import script from "./CarteiraDashboardApp.vue?vue&type=script&lang=js"
export * from "./CarteiraDashboardApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports